// extracted by mini-css-extract-plugin
export default {"toggle":"toggle___el8to","open":"open___3UlUh","header":"header___U3ZAx","content":"content___1lFzs"};